import {create } from "zustand"
import toast from "react-hot-toast";
import axios from "axios";
import { applyMode, applyTheme } from "../lib/SetColours";

const BASE_URL = process.env.REACT_APP_BASE_URL || (process.env.REACT_APP_MODE === "development" ? "http://localhost:4000/api/v1" : "https://bloggr-y7gx.onrender.com/api/v1");


export const useSettingsStore = create((set,get)=>({
   theme:"Green",
   mode:"Light",
   

   setSettings:async(data)=>{
      try{
         const response = await axios.post(`${BASE_URL}/settings/setsettings`, data, { withCredentials: true });

         if(response.data.success){
            toast.success("Settings saved Successfully");
            return true;
         }
         else{
            toast.error("Error in saving the settings, please try again after some time");
            return false;
         }
      }

      catch(e){
         console.error("setSettings error:", e.response?.data || e.message);
         toast.error(e.response?.data?.message || "Error in saving the settings, please try again after some time");
         return false;
      }
   },
   getSettings: async () => {
      try {
         const response = await axios.get(`${BASE_URL}/settings/getsettings`, { withCredentials: true });

         if (response.data.success) {
            set({ theme: response.data.data.theme });
            set({ mode: response.data.data.mode });
            localStorage.setItem("accent-theme", response.data.data.theme);
            localStorage.setItem("accent-mode", response.data.data.mode);
            applyMode(response.data.data.mode);
            applyTheme(response.data.data.theme);
            return response.data.data;
         }
         return null;
      }
      catch (e) {
         return null;
      }
   },

   resetSettings: async()=>{
      try{

         const response = await axios.get(`${BASE_URL}/settings/resetsettings`, { withCredentials: true });
         if(response.data.success){
            toast.success("Settings reset Completed!")
            return true;
         }
         else{
            toast.error("Error occured in resetting the settings!")
            return false;
         }
      }
      catch(e){
         console.error("resetSettings error:", e.response?.data || e.message);
         toast.error(e.response?.data?.message || "Error occured in resetting the settings!")
         return false;
      }
   }
}))